import React, { Component } from 'react';
import { Col, Row } from 'react-bootstrap';
import toastr from 'toastr';
import { HeaderBar } from '../components/HeaderBar.js';
import { CollapsablePanel } from '../components/CollapsablePanel';
import { DashboardChart } from '../components/DashboardChart';
import { MessagePanel } from '../components/MessagePanel';

export class MainDashboard extends Component {

    constructor(props) {
      super(props);
    }

    onChangeView = (e) => {

      this.props.history.push('/'+e);
    }

    render() {
        return(
            <div>
            <HeaderBar onChangeView={this.onChangeView} actualPosition={"Main Dashboard"}></HeaderBar>

            <Row className="gray-bg">

              <Col xs={12} sm={12} md={12} lg={12} >


                          <div className="wrapper wrapper-content">
                      <div className="row">
                                  <div className="col-lg-3">
                                      <div className="ibox float-e-margins ">
                                          <div className="ibox-title">
                                              <span className="label label-success pull-right">Monthly</span>
                                              <h5>Revenue</h5>
                                          </div>
                                          <div className="ibox-content top-summary-box-content">
                                              <h1 className="no-margins">$16,640,787 ​</h1>
                                              <small>Total income</small>
                                          </div>
                                      </div>
                                  </div>
                                  <div className="col-lg-3">
                                      <div className="ibox float-e-margins ">
                                          <div className="ibox-title">
                                              <span className="label label-info pull-right">Annual</span>
                                              <h5>Average Margin</h5>
                                          </div>
                                          <div className="ibox-content top-summary-box-content">
                                              <h1 className="no-margins">17.4%</h1>
                                              <div className="stat-percent font-bold text-info">20% <i className="fa fa-level-up"></i></div>

                                          </div>

                                      </div>
                                  </div>
                                  <div className="col-lg-3">
                                      <div className="ibox float-e-margins ">
                                          <div className="ibox-title">
                                              <span className="label label-primary pull-right">Today</span>
                                              <h5>Active Loads</h5>
                                          </div>
                                          <div className="ibox-content top-summary-box-content">
                                              <h1 className="no-margins">144</h1>
                                              <div className="stat-percent font-bold text-green">9% <i className="fa fa-level-up"></i></div>

                                          </div>

                                      </div>
                                  </div>
                                  <div className="col-lg-3">
                                      <div className="ibox float-e-margins ">
                                          <div className="ibox-title">
                                              <span className="label label-danger pull-right">Good</span>
                                              <h5>Gross ​Margin</h5>
                                          </div>
                                          <div className="ibox-content top-summary-box-content">
                                              <h1 className="no-margins">$2,912,454</h1>
                                              <div className="stat-percent font-bold text-green">4% <i className="fa fa-level-up"></i></div>
                                              <small>In first month</small>
                                          </div>
                                      </div>
                          </div>
                      </div>
                      <div className="row">
                                  <div className="col-lg-12">
                                      <div className="ibox float-e-margins">
                                          <div className="ibox-title">
                                              <h5>Receivables Ageing </h5>
                                              <div className="pull-right">
                                                  <div className="btn-group">
                                                      <button type="button" className="btn btn-xs btn-white ">Today</button>
                                                      <button type="button" className="btn btn-xs btn-white active">Monthly</button>
                                                      <button type="button" className="btn btn-xs btn-white">Annual</button>
                                                  </div>
                                              </div>
                                          </div>
                                          <div className="ibox-content">
                                              <div className="row">
                                              <div className="col-lg-9">
                                                  <div className="flot-chart">
                                                      <div className="flot-chart-content" id="flot-dashboard-chart">
                                                        <DashboardChart></DashboardChart>
                                                      </div>
                                                  </div>
                                              </div>
                                              <div className="col-lg-3">
                                                  <ul className="stat-list">
                                                      <li>
                                                          <h2 className="no-margins">2.346</h2>
                                                          <small>Loads paid for with NXXT Tokens</small>
                                                          <div className="stat-percent font-bold text-green">4% <i className="fa fa-level-up "></i></div>
                                                          <div className="progress progress-mini">
                                                              <div className="progress-bar" style={{width: '50%'}}></div>
                                                          </div>
                                                      </li>
                                                      <li>
                                                          <h2 className="no-margins ">4.422</h2>
                                                          <small>Loads Paid for with other Tokens</small>
                                                          <div className="stat-percent font-bold text-danger">1% <i className="fa fa-level-down text-navy"></i></div>
                                                          <div className="progress progress-mini">
                                                              <div className="progress-bar" style={{width: '20%'}}></div>
                                                          </div>
                                                      </li>
                                                      <li>
                                                          <h2 className="no-margins ">9.180</h2>
                                                          <small>Loads Paid for Fiat Currencies</small>
                                                          <div className="stat-percent font-bold text-green">3% <i className="fa fa-level-up text-green"></i></div>
                                                          <div className="progress progress-mini">
                                                              <div  className="progress-bar" style={{width: '70%'}}></div>
                                                          </div>
                                                      </li>
                                                      </ul>
                                                  </div>
                                              </div>
                                              </div>

                                          </div>
                                      </div>
                                  </div>


                              <div className="row">
                                  <div className="col-lg-4">
                                      <MessagePanel></MessagePanel>
                                  </div>

                                  <div className="col-lg-8">



                                  <div className="row">
                                      <div className="col-lg-12">
                                          <div className="ibox float-e-margins">
                                              <div className="ibox-title">
                                                  <h5>Open Business</h5>

                                              </div>

                                              <div className="ibox-content">
                                                  <div className="row">
                                                      <div className="col-lg-12">
                                                          <table className="table table-hover margin bottom">
                                                              <thead>
                                                              <tr>
                                                                  <th  className="text-center">No.</th>
                                                                  <th>Transaction</th>
                                                                  <th className="text-center">Date</th>
                                                                  <th className="text-center">Amount</th>
                                                              </tr>
                                                              </thead>
                                                              <tbody>
                                                              <tr>
                                                                  <td className="text-center">1</td>
                                                                  <td>  Juniper Networks, #36843
                                                                      </td>
                                                                  <td className="text-center small">16 Jun 2017</td>
                                                                  <td className="text-center"><span className="label label-primary">$ 483.00</span></td>

                                                              </tr>
                                                              <tr>
                                                                  <td className="text-center">2</td>
                                                                  <td> Domus Design Corp, #36789
                                                                  </td>
                                                                  <td className="text-center small">10 Jun 2017</td>
                                                                  <td className="text-center"><span className="label label-primary">$ 327.00</span></td>

                                                              </tr>
                                                              <tr>
                                                                  <td className="text-center">3</td>
                                                                  <td> Apax Corp, # 36798
                                                                  </td>
                                                                  <td className="text-center small">12 Jun 2017</td>
                                                                  <td className="text-center"><span className="label label-warning">$ 125.00</span></td>

                                                              </tr>
                                                              <tr>
                                                                  <td className="text-center">4</td>
                                                                  <td>  Juniper Networks, #36876</td>
                                                                  <td className="text-center small">22 Jun 2017</td>
                                                                  <td className="text-center"><span className="label label-primary">$ 344.00</span></td>
                                                              </tr>
                                                              <tr>
                                                                  <td className="text-center">5</td>
                                                                  <td>Ellington Electric, #36888</td>
                                                                  <td className="text-center small">24 Jun 2017</td>
                                                                  <td className="text-center"><span className="label label-primary">$ 235.00</span></td>
                                                              </tr>
                                                              <tr>
                                                                  <td className="text-center">6</td>
                                                                  <td>Johnson Controls, #36887</td>
                                                                  <td className="text-center small">26 Jun 2017</td>
                                                                  <td className="text-center"><span className="label label-primary">$ 100.00</span></td>
                                                              </tr>
                                                              <tr>
                                                                  <td className="text-center">6</td>
                                                                  <td> Johnson Controls, #36823</td>
                                                                  <td className="text-center small">26 Jun 2017</td>
                                                                  <td className="text-center"><span className="label label-primary">$ 100.00</span></td>
                                                              </tr>
                                                              </tbody>
                                                          </table>

                                                          </div>

                                                    </div>
                                              </div>
                                          </div>
                                      </div>
                                  </div>









                                      <div className="row">
                                          <div className="col-lg-6">
                                              <div className="ibox float-e-margins">
                                                  <div className="ibox-title">
                                                      <h5>On Going Delivery</h5>

                                                  </div>
                                                  <div className="ibox-content">
                                                      <table className="table table-hover no-margins">
                                                          <thead>
                                                          <tr>
                                                              <th>Status</th>
                                                              <th>Date</th>
                                                              <th>Zip</th>
                                                              <th>Phone</th>
                                                          </tr>
                                                          </thead>
                                                          <tbody>
                                                          <tr>
                                                              <td><small>Pending...</small></td>
                                                              <td><i className="fa fa-clock-o"></i> 11:20pm</td>
                                                              <td>22313</td>
                                                              <td className="text-success"> 765-5556.2648 </td>
                                                          </tr>
                                                          <tr>
                                                              <td><span className="label label-warning">Canceled</span> </td>
                                                              <td><i className="fa fa-clock-o"></i> 10:40am</td>
                                                              <td>12753</td>
                                                              <td className="text-success"> 765-5556.2648 </td>
                                                          </tr>
                                                          <tr>
                                                              <td><small>Pending...</small> </td>
                                                              <td><i className="fa fa-clock-o"></i> 01:30pm</td>
                                                              <td>19465</td>
                                                              <td className="text-success"> 765-5556.2648 </td>
                                                          </tr>
                                                          <tr>
                                                              <td><small>Pending...</small> </td>
                                                              <td><i className="fa fa-clock-o"></i> 02:20pm</td>
                                                              <td>09456</td>
                                                              <td className="text-success"> 765-5556.2648 </td>
                                                          </tr>
                                                          <tr>
                                                              <td><small>Pending...</small> </td>
                                                              <td><i className="fa fa-clock-o"></i> 09:40pm</td>
                                                              <td>02378</td>
                                                              <td className="text-success"> 765-5556.2648 </td>
                                                          </tr>
                                                          <tr>
                                                              <td><span className="label label-primary">Completed</span> </td>
                                                              <td><i className="fa fa-clock-o"></i> 04:10am</td>
                                                              <td>28374</td>
                                                              <td className="text-success"> 765-5556.2648 </td>
                                                          </tr>
                                                          <tr>
                                                              <td><small>Pending...</small> </td>
                                                              <td><i className="fa fa-clock-o"></i> 12:08am</td>
                                                              <td>27384</td>
                                                              <td className="text-success"> 765-5556.2648 </td>
                                                          </tr>
                                                          </tbody>
                                                      </table>
                                                  </div>
                                              </div>
                                          </div>



                                          <div className="col-lg-6">

                                              <div className="ibox float-e-margins">
                                                  <div className="ibox-title">
                                                      <h5>Task List</h5>

                                                  </div>
                                                  <div className="ibox-content">
                                                      <ul className="todo-list m-t small-list">
                                                          <li>
                                                              <a  className="check-link"><i className="fa fa-square-o"></i> </a>
                                                              <span className="m-l-xs">Renew Surety Bond</span>

                                                          </li>
                                                          <li>
                                                              <a  className="check-link"><i className="fa fa-square-o"></i> </a>
                                                              <span className="m-l-xs">Update Jose Gutierrez Credentials</span>

                                                          </li>
                                                          <li>
                                                              <a  className="check-link"><i className="fa fa-square-o"></i> </a>
                                                              <span className="m-l-xs">Send Holiday gift to Anne Schmidt at Domus Design Corp.</span>
                                                              <small className="label label-primary"><i className="fa fa-clock-o"></i> 1 mins</small>
                                                          </li>
                                                          <li>
                                                              <a  className="check-link"><i className="fa fa-square-o"></i> </a>
                                                              <span className="m-l-xs">Revise Master Continuing Contract with Smart Contract engineers</span>
                                                          </li>
                                                          <li>
                                                              <a  className="check-link"><i className="fa fa-square-o"></i> </a>
                                                              <span className="m-l-xs ">Settle end of year IFTA reports</span>
                                                          </li>
                                                          <li>
                                                              <a  className="check-link"><i className="fa fa-square-o"></i> </a>
                                                              <span className="m-l-xs">Submit ELD reports to Audit Blockchain</span>
                                                          </li>

                                                      </ul>
                                                  </div>
                                              </div>
                                          </div>
                                      </div>








                                  </div>
                              </div>
                          </div>










              </Col>

            </Row>
            </div>
            );
    }
}
;



// WEBPACK FOOTER //
// ./src/pages/MainDashboard.js